import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AuthService } from '../../auth/auth.service';
import { environment } from 'src/environments/environment';

const endpoint = environment.apiBaseUrl + '/admin/menu';
const endpointAsistentes = environment.apiBaseUrl + '/admin/asistente';

@Injectable({
  providedIn: 'root'
})
export class AsistenteMenuService {

  constructor(
    private readonly httpClient: HttpClient,
    private readonly authService: AuthService
  ) { }

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }


  loadMenuByID(idMenu) {
    return this.httpClient.get<any>(endpoint + `/display/${idMenu}`).pipe(map(this.extractData));
  }

  agregarMenu(codigoAsistente, descripcion, nombre, gafuAreaFuncional, updateUser) {
    const params = {
      codigoAsistente: codigoAsistente,
      descripcion: descripcion,
      nombre: nombre,
      gafuAreaFuncional: gafuAreaFuncional,
      userName: updateUser
    }
    return this.httpClient.post(`${endpoint}/add`, params)
  }

  actualizarMenu(codigoAsistente, idMenu, descripcion, nombre, gafuAreaFuncional, updateUser, habilitado) {
    const params = {
      idAsistente: idMenu,
      codigoAsistente: codigoAsistente,
      descripcion: descripcion,
      nombre: nombre,
      gafuAreaFuncional: gafuAreaFuncional,
      userName: updateUser,
      habilitado: habilitado
    }
    return this.httpClient.post(`${endpoint}/update`, params)
  }
}
